"use client";

import { useContext } from "react";

import { DebugContext, type DebugContextState } from "../contexts/DebugContext";

/**
 * Hook to access the Debug context
 * @returns The debug context state
 * @throws Error if used outside of DebugProvider
 */
export const useDebug = (): DebugContextState => {
  const context = useContext(DebugContext);
  if (!context) {
    throw new Error("useDebug must be used within a DebugProvider");
  }

  return context;
};
